import React from 'react';
import { animated, useTransition } from '@react-spring/web';
import cx from 'classnames';

import styles from './styles.module.scss';
import Button from 'src/components/button';

const LOGO = '/images/seek.gif';

interface Props {
    isHistory: boolean;
    showSummarize?: boolean;
    onExitHistory: () => void;
    onOpenHistory: () => void;
    toggleSummary?: () => void;
    isChatLoading?: boolean;
    dealId?: string;
    onExpandChat?: () => void;
    showExpandChat?: boolean;
}

const Header: React.FC<Props> = ({
    isHistory,
    showSummarize = false,
    onExitHistory,
    onOpenHistory,
    toggleSummary,
    isChatLoading,
    dealId,
    onExpandChat,
    showExpandChat = false,
}) => {
    // Transitions
    const historyTransition = useTransition(isHistory, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { tension: 280, friction: 30 },
    });

    const summarizeTransition = useTransition(showSummarize && dealId, {
        from: {
            opacity: 0,
            transform: 'translateY(-4px)',
        },
    
        enter: {
            opacity: 1,
            transform: 'translateY(0px)',
        },
    
        leave: {
            opacity: 0,
            transform: 'translateY(-4px)',
        },
    
        config: {
            tension: 260,
            friction: 24,
        },
    });

    return (
        <div className={styles.agentHeader}>
            <div className={styles.container}>
                {historyTransition((springStyle, showHistory) =>
                    showHistory ? (
                        <animated.div
                            style={springStyle}
                            className={cx(styles.content, styles.history)}
                        >
                            <Button className={styles.actionButton} onClick={onExitHistory}>
                                <i className="paperflite-close" /> 
                                <p className={styles.label}>history</p>
                            </Button> 
                        </animated.div>
                    ) : ( <animated.div
                            style={springStyle}
                            className={cx(
                                styles.content,
                                styles.main
                            )}
                        >
                            <div className={styles.brand}>
                                <img
                                    className={styles.logo}
                                    src={LOGO}
                                    alt=""
                                />
                                <p className={styles.title}>deal agent</p>
                            </div>

                            <div className={styles.actions}>
                                {summarizeTransition((style, show) =>
                                    show ? (
                                        <animated.div style={style}>
                                            <Button disabled={isChatLoading} className={cx(styles.actionButton, styles.summaryAction)} onClick={toggleSummary}>
                                               <i className="paperflite-stars" />
                                            </Button>
                                        </animated.div>
                                    ) : null
                                )}

                               {dealId && <Button disabled={isChatLoading} className={cx(styles.actionButton, styles.historyAction)} onClick={onOpenHistory}>
                                    <i className="paperflite-history" />
                                </Button>}

                                { !dealId && showExpandChat && <Button disabled={isChatLoading} className={cx(styles.actionButton, styles.dropdownAction)} onClick={onExpandChat}>
                                    <i className="paperflite-dropdown" />
                                </Button>}
                            </div>
                        </animated.div>
                ))}
            </div>
        </div>
    );
};

export default Header;
